/**
 *  @class
 *  @function RemoveAll
 */
if (!customElements.get('remove-all')) {
  class RemoveAll extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.drawer = this.closest('cart-drawer');
      
      // Check if debounce is available
      if (typeof debounce === 'undefined') {
        console.error('[Remove All] debounce function not available');
        this.addEventListener('click', () => this.onSubmitHandler());
      } else {
        this.debouncedOnSubmit = debounce(() => {
          this.onSubmitHandler();
        }, 200);
        this.addEventListener('click', this.debouncedOnSubmit.bind(this));
      }
    }
    
    onSubmitHandler() {
      console.log('[Remove All] Starting cart clear...');
      
      if (!this.drawer) {
        console.error('[Remove All] Cart drawer not found');
        return;
      }
      
      this.classList.add('loading');
      
      // Get note value safely
      const notesField = document.getElementById('mini-cart__notes');
      const noteValue = notesField ? notesField.value : '';
      
      fetch(`${theme.routes.cart_clear_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          'note': noteValue
        })
      })
      .then((response) => {
        console.log('[Remove All] Response status:', response.status);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        return response.json();
      })
      .then((cart) => {
        console.log('[Remove All] Cart cleared successfully:', cart);
        
        this.classList.remove('loading');
        
        // Refresh drawer
        if (this.drawer && typeof this.drawer.refresh === 'function') {
          this.drawer.refresh();
        } else {
          // Fallback: dispatch cart:refresh event
          console.log('[Remove All] Using fallback refresh event');
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', { bubbles: true })
          );
        }
      })
      .catch((error) => {
        console.error('[Remove All] Error clearing cart:', error);
        this.classList.remove('loading');
        
        // Show error to user
        alert('Could not clear cart. Please try again.');
      });
    }
  }
  customElements.define('remove-all', RemoveAll);
}